import dynamic from "next/dynamic";
import usePopupVisibility from "@/components/PopupForm/usePopupVisibility";
import {useState, useEffect, useRef} from "react";

const PopupForm = dynamic(() => import ("@/components/PopupForm/PopupForm"), {ssr: false});

const HeroBanner = dynamic(() => import ("@/components/HomeBanner/HomeBanner"), {
    loading: () => <div style={
        {
            minHeight: "80vh",
            background: "#f5f5f5"
        }
    }/>,
    ssr: typeof window === "undefined" ? true : window.innerWidth > 768
});

const TransformativeHome = dynamic(() => import ("@/components/TransformativeHome/TransformativeHome"), {
    loading: () => (
        <div style={
            {
                minHeight: "300px",
                background: "#f5f5f5"
            }
        }/>
    ),
    ssr: typeof window === "undefined" ? true : window.innerWidth > 768
});

const ExploreFuture = dynamic(() => import ("@/components/ExploreFuture/ExploreFuture"), {
    loading: () => (
        <div style={
            {
                minHeight: "300px",
                background: "#f5f5f5"
            }
        }/>
    ),
    ssr: false
});

const AccreditationHome = dynamic(() => import ("@/components/AccreditationHome/AccreditationHome"), {ssr: false});

const StudentFunding = dynamic(() => import ("@/components/StudentFunding/StudentFunding"), {ssr: false});

const InsightsHighlights = dynamic(() => import ("@/components/InsightsHighlights/InsightsHighlights"), {ssr: false});

const HomeTestimonials = dynamic(() => import ("@/components/HomeTestimonials/HomeTestimonials"), {ssr: false});

const ThroughResearch = dynamic(() => import ("@/components/ThroughResearch/ThroughResearch"), {ssr: false});

const StickyFooter = dynamic(() => import ("@/components/StickyFooter/StickyFooter"), {
    ssr: false,
    loading: () => <div style={
        {
            height: "60px",
            background: "#ddd"
        }
    }/>
});
const YoutubeVidioPopup = dynamic(() => import ("@/components/YoutubeVidioPopup/YoutubeVidioPopup"), {ssr: false});

const StudentLife = dynamic(() => import ("@/components/StudentLife/StudentLife"), {ssr: false});

const Layout = dynamic(() => import ("@/components/Layout/Layout"), {ssr: false});

interface HomeProps {
    cmsData: any | null;
    commonData: any | null;
}

export default function CountryHome({cmsData, commonData} : HomeProps) {
    const {
        isPopupVisible,
        hidePopup,
        iscrollPopupVisible,
        scrollshowPopup,
        scrollHidePopup
    } = usePopupVisibility();

    const [isYoutubePopup, setIsisYoutubePopup] = useState(false);
    const [isFooterLoaded, setIsFooterLoaded] = useState(false);
    const [showBelowFold, setShowBelowFold] = useState(false);
    const screenShowRef = useRef < HTMLDivElement | null > (null);

    useEffect(() => {
        const timer = setTimeout(() => setIsFooterLoaded(true), 3000);
        return() => clearTimeout(timer);
    }, []);

    const popupTiming = (cmsData ?. popup_section ?. popup_visible_time_in_sec || 5) * 1000;

    useEffect(() => {
        const isPopupShown = localStorage.getItem("popupShown");
        if (isPopupShown) 
            return;
        

        const handleScroll = () => {
            const experienceSection = document.getElementById("experience-section");
            if (! experienceSection) 
                return;
            

            const {top} = experienceSection.getBoundingClientRect();
            if (top < window.innerHeight * 0.5) {
                setTimeout(() => {
                    scrollshowPopup();
                    localStorage.setItem("popupShown", "true");
                }, popupTiming);

                window.removeEventListener("scroll", handleScroll);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return() => window.removeEventListener("scroll", handleScroll);
    }, [popupTiming, scrollshowPopup]);

    const handleClosePopup = () => {
        hidePopup();
        scrollHidePopup();
    };

    const handleYoutubePopupClose = () => {
        setIsisYoutubePopup(false);
    };

    const {
        home_banner,
        transformative_learning,
        explore_your_future,
        accreditations,
        testimonial,
        through_research,
        student_funding,
        insights_and_highlights,
        student_life,
        sticky_footer
    } = cmsData || {};

    const StickyFooterComponent = sticky_footer ?. is_sticky_footer_enabled ? sticky_footer : commonData ?. sticky_footer ?. is_sticky_footer_enabled ? commonData ?. sticky_footer : null;

    useEffect(() => {
        const onScroll = () => {
            if (window.scrollY > 100) {
                setShowBelowFold(true);
                window.removeEventListener("scroll", onScroll);
            }
        };

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setShowBelowFold(true);
                observer.disconnect();
            }
        }, {
            rootMargin: "0px",
            threshold: 0.1
        });

        if (screenShowRef.current) {
            observer.observe(screenShowRef.current);
        }

        window.addEventListener("scroll", onScroll);

        return() => {
            window.removeEventListener("scroll", onScroll);
            observer.disconnect();
        };
    }, []);

    return (
        <>
            <Layout SeoData={
                    cmsData ?. seo_data
                }
                pageName="home"
                commonData={commonData}>
                <HeroBanner data={home_banner}/> {
                transformative_learning && (
                    <TransformativeHome data={transformative_learning}
                        page="home"/>
                )
            }
                {
                explore_your_future && <ExploreFuture data={explore_your_future}/>
            }
                {
                showBelowFold && (
                    <> {
                        accreditations && <AccreditationHome data={accreditations}/>
                    }
                        {
                        testimonial && <HomeTestimonials data={testimonial}/>
                    }
                        <div id="experience-section"></div>

                        {
                        through_research && <ThroughResearch data={through_research}/>
                    }
                        {
                        student_funding && <StudentFunding data={student_funding}/>
                    }
                        {
                        student_life && <StudentLife data={student_life}/>
                    }
                        {
                        insights_and_highlights && (
                            <InsightsHighlights data={insights_and_highlights}/>
                        )
                    }
                        {
                        isFooterLoaded && StickyFooterComponent && (
                            <StickyFooter data={StickyFooterComponent}/>
                        )
                    }
                        {
                        isPopupVisible && (
                            <PopupForm isVisible={isPopupVisible}
                                onClose={handleClosePopup}/>
                        )
                    }
                        {
                        iscrollPopupVisible && (
                            <PopupForm isVisible={iscrollPopupVisible}
                                onClose={handleClosePopup}
                                redirectlink={
                                    cmsData ?. popup_section ?. common_popup ?. title_link ?. link ?. url
                                }
                                popUpData={
                                    cmsData ?. popup_section
                                }/>
                        )
                    }
                        {
                        isYoutubePopup && (
                            <YoutubeVidioPopup isVisibleVideo={isYoutubePopup}
                                youtubeVideoLink={""}
                                onClose={handleYoutubePopupClose}/>
                        )
                    } </>
                )
            } </Layout>
        </>
    );
}
